<div class="container my-4">
   <h2 class="mt-5">Legale Rappresentante Impresa - Dati Personali</h2>

   <form class="w-full mx-auto mt-7 form-modal" [formGroup]="userFrm">
      <div class="grid grid-cols-12 gap-4 pb-0">
         <mat-form-field class="col-span-12 lg:col-span-4" appearance="fill">
            <mat-label>Nome</mat-label>
            <input matInput type="text" formControlName="first_name">
            <mat-error *ngIf="userFrm.get('first_name')?.hasError('required')">
               Il Nome è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field class="col-span-12 lg:col-span-4" appearance="fill">
            <mat-label>Cognome</mat-label>
            <input matInput type="text" formControlName="last_name">
            <mat-error *ngIf="userFrm.get('last_name')?.hasError('required')">
               Il Cognome è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field class="col-span-12 lg:col-span-4" appearance="fill" formGroupName="profile">
            <mat-label>Data di Nascita</mat-label>
            <input matInput type="date" formControlName="data_nascita">
            <mat-error *ngIf="userFrm.get('profile.data_nascita')?.hasError('required')">
               La Data di Nascita è <strong>obbligatoria</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field class="col-span-12 lg:col-span-4" appearance="fill" formGroupName="profile">
            <mat-label>Codice Fiscale</mat-label>
            <input matInput type="text" formControlName="codice_fiscale">
            <mat-error *ngIf="userFrm.get('profile.codice_fiscale')?.hasError('required')">
               Il codice fiscale è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-2 lg:col-span-2" formGroupName="profile">
            <mat-label>Prefisso</mat-label>
            <mat-select formControlName="cellulare_prefix">
               <mat-option *ngFor="let item of flags"
                           [value]="item.value">
                  <span>{{item.flag}}</span> {{item.value}}
               </mat-option>
            </mat-select>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-10 lg:col-span-6" formGroupName="profile">
            <mat-label>Cellulare</mat-label>
            <input matInput type="text" formControlName="cellulare">
            <mat-error *ngIf="userFrm.get('cellulare')?.hasError('required')">
               Il Numero di Cellulare è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-12">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" (blur)="setValueUsername($event)">
            <mat-icon matSuffix
                      *ngIf="utente_esercizio?.data?.profile?.data?.email_convalidata"
                      matTooltip="Email confermata">done</mat-icon>
            <mat-icon matSuffix color="warn" *ngIf="!utente_esercizio?.data?.profile?.data?.email_convalidata"
                      matTooltip="Email non confermata">clear</mat-icon>
            <mat-error *ngIf="userFrm.get('email')?.hasError('email')">
               Inserire un indirizzo email valido
            </mat-error>
            <mat-error *ngIf="userFrm.get('email')?.hasError('required')">
               L'email è <strong>obbligatoria</strong>
            </mat-error>
         </mat-form-field>

         <!--         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-6">-->
         <!--            <mat-label>Username</mat-label>-->
         <!--            <input matInput type="email" formControlName="username">-->
         <!--            <mat-error *ngIf="userFrm.get('username')?.hasError('email')">-->
         <!--               Inserire un indirizzo email valido-->
         <!--            </mat-error>-->
         <!--            <mat-error *ngIf="userFrm.get('username')?.hasError('required')">-->
         <!--               L'username è <strong>obbligatorio</strong>-->
         <!--            </mat-error>-->
         <!--         </mat-form-field>-->

         <mat-form-field *ngIf="isNew" appearance="fill" class="col-span-12 lg:col-span-6">
            <mat-label>password</mat-label>
            <input matInput type="password" formControlName="password">
            <mat-error *ngIf="userFrm.get('password')?.hasError('required')">
               Password <strong>obbligatoria</strong>
            </mat-error>
         </mat-form-field>
      </div>

      <div formGroupName="profile" class="grid grid-cols-12 gap-4">
         <h2 class="mt-5 col-span-12">Legale Rappresentante Impresa - Luogo di Nascita</h2>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_nascita">
            <mat-label>Seleziona uno stato</mat-label>
            <mat-select (selectionChange)="setValueStato($event.value, 'profile', 'indirizzo_nascita')" formControlName="stato">
               <mat-option *ngFor="let stato of this.arrStati" value="{{stato.data.id}}">{{stato.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_nascita')?.get('stato')?.hasError('required')">
               Inserisci lo stato
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_nascita">
            <mat-label>Luogo di nascita - Regione</mat-label>
            <mat-select (selectionChange)="setValueProvince($event.value, 'indirizzo_nascita')" formControlName="regione">
               <mat-option *ngFor="let regioni of this.arrRegioni"
                           value="{{regioni.data.id}}">{{regioni.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_nascita')?.get('regione')?.hasError('required')">
               Inserisci la regione
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_nascita">
            <mat-label>Luogo di nascita - Provincia</mat-label>
            <mat-select (selectionChange)="setValueCitta($event.value, 'indirizzo_nascita')"
                        formControlName="provincia">
               <mat-option *ngFor="let provincia of this.arrProvinceNascita"
                           value="{{provincia.data.id}}">{{provincia.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_nascita')?.get('provincia')?.hasError('required')">
               Inserisci la provincia
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_nascita">
            <mat-label>Luogo di nascita - Città</mat-label>
            <mat-select formControlName="citta">
               <mat-option *ngFor="let citta of this.arrCittaNascita" value="{{citta.data.id}}">{{citta.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_nascita')?.get('citta')?.hasError('required')">
               Inserisci la citta
            </mat-error>
         </mat-form-field>

         <h2 class="mt-5 col-span-12">Legale Rappresentante Impresa - Luogo di Residenza</h2>
         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_residenza">
            <mat-label>Seleziona uno stato</mat-label>
            <mat-select (selectionChange)="setValueStato($event.value, 'profile', 'indirizzo_residenza')" formControlName="stato">
               <mat-option *ngFor="let stato of this.arrStati" value="{{stato.data.id}}">{{stato.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('stato')?.hasError('required')">
               Inserisci lo stato
            </mat-error>
         </mat-form-field>
         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_residenza">
            <mat-label>Indirizzo di residenza - Regione</mat-label>
            <mat-select (selectionChange)="setValueProvince($event.value, 'indirizzo_residenza')" formControlName="regione">
               <mat-option *ngFor="let regioni of this.arrRegioni"
                           value="{{regioni.data.id}}">{{regioni.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('regione')?.hasError('required')">
               Inserisci la regione
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_residenza">
            <mat-label>Indirizzo di residenza - Provincia</mat-label>
            <mat-select (selectionChange)="setValueCitta($event.value, 'indirizzo_residenza')"
                        formControlName="provincia">
               <mat-option *ngFor="let provincia of this.arrProvinceResidenza"
                           value="{{provincia.data.id}}">{{provincia.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('provincia')?.hasError('required')">
               Inserisci la provincia
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_residenza">
            <mat-label>Indirizzo di residenza - Città</mat-label>
            <mat-select formControlName="citta">
               <mat-option *ngFor="let citta of this.arrCittaResidenza" value="{{citta.data.id}}">{{citta.data.nome}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('citta')?.hasError('required')">
               Inserisci la citta
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-8" formGroupName="indirizzo_residenza">
            <mat-label>Indirizzo</mat-label>
            <input matInput type="text" formControlName="indirizzo">
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('indirizzo')?.hasError('required')">
               L'indirizzo è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-2" formGroupName="indirizzo_residenza">
            <mat-label>Civico</mat-label>
            <input matInput type="text" formControlName="civico">
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('civico')?.hasError('required')">
               Il civico è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-12 lg:col-span-2" formGroupName="indirizzo_residenza">
            <mat-label>CAP</mat-label>
            <input matInput type="text" formControlName="cap">
            <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_residenza')?.get('cap')?.hasError('required')">
               Il cap è <strong>obbligatorio</strong>
            </mat-error>
         </mat-form-field>

         <div class="col-span-12 mb-5">
            <h2>L'indirizzo di domicilio è diverso o uguale a quello di residenza?</h2>
            <div>
               <label id="example-radio-group-label">Scegli un'opzione</label>
            </div>
            <mat-radio-group aria-label="Select an option" formControlName="ind_res_match" class="col-span-12" (change)="setIndirizzoDomicilio($event)">
               <mat-radio-button [value]="false" class="mx-2">Diverso</mat-radio-button>
               <mat-radio-button [value]="true" class="mx-2">Uguale</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="userFrm.get('profile')?.get('ind_res_match')?.hasError('required') && userFrm.get('profile')?.get('ind_res_match')?.touched ">
               Il campo è obbligatorio <strong>obbligatorio</strong>
            </mat-error>
         </div>

         <ng-container *ngIf="userFrm.get('profile')?.get('ind_res_match')?.value == false">
            <h2 class="mt-5 col-span-12">Legale Rappresentante Impresa - Luogo di Domicilio</h2>
            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_domicilio">
               <mat-label>Seleziona uno stato</mat-label>
               <mat-select (selectionChange)="setValueStato($event.value, 'profile', 'indirizzo_domicilio')" formControlName="stato">
                  <mat-option *ngFor="let stato of this.arrStati" value="{{stato.data.id}}">{{stato.data.nome}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('stato')?.hasError('required')">
                  Inserisci lo stato
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_domicilio">
               <mat-label>Indirizzo di domicilio - Regione</mat-label>
               <mat-select (selectionChange)="setValueProvince($event.value, 'indirizzo_domicilio')" formControlName="regione">
                  <mat-option *ngFor="let regioni of this.arrRegioni"
                              value="{{regioni.data.id}}">{{regioni.data.nome}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('regione')?.hasError('required')">
                  Inserisci la regione
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_domicilio">
               <mat-label>Indirizzo di domicilio - Provincia</mat-label>
               <mat-select (selectionChange)="setValueCitta($event.value, 'indirizzo_domicilio')"
                           formControlName="provincia">
                  <mat-option *ngFor="let provincia of this.arrProvinceDomicilio"
                              value="{{provincia.data.id}}">{{provincia.data.nome}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('provincia')?.hasError('required')">
                  Inserisci la provincia
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-3" formGroupName="indirizzo_domicilio">
               <mat-label>Indirizzo di domicilio - Città</mat-label>
               <mat-select formControlName="citta">
                  <mat-option *ngFor="let citta of this.arrCittaDomicilio" value="{{citta.data.id}}">{{citta.data.nome}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('citta')?.hasError('required')">
                  Inserisci la citta
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-8" formGroupName="indirizzo_domicilio">
               <mat-label>Indirizzo</mat-label>
               <input matInput type="text" formControlName="indirizzo">
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('indirizzo')?.hasError('required')">
                  L'indirizzo è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-2" formGroupName="indirizzo_domicilio">
               <mat-label>Civico</mat-label>
               <input matInput type="text" formControlName="civico">
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('civico')?.hasError('required')">
                  Il civico è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-span-12 lg:col-span-2" formGroupName="indirizzo_domicilio">
               <mat-label>CAP</mat-label>
               <input matInput type="text" formControlName="cap">
               <mat-error *ngIf="userFrm.get('profile')?.get('indirizzo_domicilio')?.get('cap')?.hasError('required')">
                  Il cap è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>
         </ng-container>


            <!--         <div class="col-span-12 mb-5">-->
            <!--            <h2>L'indirizzo di domicilio è diverso o uguale a quello di residenza?</h2>-->
            <!--            <div>-->
            <!--               <mat-label id="example-radio-group-labeel">Scegli un'opzione</mat-label>-->
            <!--            </div>-->
            <!--            <mat-radio-group aria-label="Select an option" formControlName="ind_res_match" class="col-span-12">-->
            <!--               <mat-radio-button [value]="false" class="mx-1">Diverso</mat-radio-button>-->
            <!--               <mat-radio-button [value]="true" class="mx-1">Uguale</mat-radio-button>-->
            <!--            </mat-radio-group>-->
            <!--            <mat-error *ngIf="userFrm.get('profile')?.get('ind_res_match')?.hasError('required') && userFrm.get('profile')?.get('ind_res_match')?.touched ">-->
            <!--               Il campo è <strong>obbligatorio</strong>-->
            <!--            </mat-error>-->
            <!--         </div>-->

            <!--         <div class="col-span-12 mb-5">-->
            <!--            <h2>L'indirizzo di domicilio è diverso o uguale a quello di residenza?</h2>-->
            <!--            <div>-->
            <!--               <mat-label id="example-radio-group-label">Scegli un'opzione</mat-label>-->
            <!--            </div>-->
            <!--            <mat-radio-group aria-label="Select an option" formControlName="ind_res_match" class="col-span-12">-->
            <!--               <mat-radio-button [value]="false" class="mx-1">Diverso</mat-radio-button>-->
            <!--               <mat-radio-button [value]="true" class="mx-1">Uguale</mat-radio-button>-->
            <!--            </mat-radio-group>-->
            <!--            <mat-error *ngIf="userFrm.get('profile')?.get('ind_res_match')?.hasError('required') && userFrm.get('profile')?.get('ind_res_match')?.touched ">-->
            <!--               Il campo è <strong>obbligatorio</strong>-->
            <!--            </mat-error>-->
            <!--         </div>-->
      </div>
      <ng-container formGroupName="esercizio">

         <h2 class="col-span-12">Documenti Legale Rappresentante</h2>
         <div class="col-span-12 lg:col-span-4">
            <mat-label>Documento Legale Rappresentante</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <ngx-mat-file-input [accept]="'.pdf'" formControlName="documento_legale_rapp" placeholder="Basic Input" valuePlaceholder="Carica Documento"></ngx-mat-file-input>
               <mat-icon matSuffix>folder</mat-icon>
               <!--                  <ngx-mat-file-input formControlName="documento_legale_rapp" accept=".pdf"></ngx-mat-file-input>-->
               <mat-error *ngIf="userFrm.get('esercizio')?.get('documento_legale_rapp')?.hasError('required') && userFrm.get('esercizio__documento_legale_rapp')?.dirty">
                  Il Documento è <strong>obbligatorio</strong>
               </mat-error>
               <mat-hint style="font-size: 13px">
                  Copia fronte-retro del documento di identità del Legale Rappresentante.
               </mat-hint>
            </mat-form-field>
         </div>

         <div class="col-span-12 lg:col-span-2">
            <mat-label>Tipo</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <mat-select formControlName="tipo_doc_legale_rapp">
                  <mat-option value="">Scegli un'opzione</mat-option>
                  <mat-option *ngFor="let tipo of Esercizio.Tipo_Documento_Leg_Rapp" [value]="tipo.value">{{tipo.display}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('esercizio')?.get('tipo_doc_legale_rapp')?.hasError('required')">
                  Il Tipo è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>
         </div>

         <div class="col-span-12 lg:col-span-4">
            <mat-label>Documento Verifica Residenza / Domicilio</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <!--                  <ngx-mat-file-input formControlName="documento_verifica" accept=".pdf"></ngx-mat-file-input>-->
               <ngx-mat-file-input [accept]="'.pdf'" formControlName="documento_verifica" placeholder="Basic Input" valuePlaceholder="Carica Documento"></ngx-mat-file-input>
               <mat-icon matSuffix>folder</mat-icon>
               <mat-error *ngIf="userFrm.get('esercizio')?.get('documento_verifica')?.hasError('required') && userFrm.get('esercizio__documento_legale_rapp')?.dirty">
                  Il Documento è <strong>obbligatorio</strong>
               </mat-error>
               <mat-hint style="font-size: 13px">
                  Documento da cui si evinca Residenza / Domicilio del Legale Rappresentante
               </mat-hint>
            </mat-form-field>
         </div>

         <div class="col-span-12 lg:col-span-2">
            <mat-label>Tipo</mat-label>
            <mat-form-field class="w-full" appearance="fill">
               <mat-select formControlName="tipo_doc_verifica">
                  <mat-option value="">Scegli un'opzione</mat-option>
                  <mat-option *ngFor="let tipo of Esercizio.Tipo_Documento_Verifica" [value]="tipo.value">{{tipo.display}}</mat-option>
               </mat-select>
               <mat-error *ngIf="userFrm.get('esercizio')?.get('tipo_doc_verifica')?.hasError('required')">
                  Il Tipo è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>
         </div>
      </ng-container>
      <div class="pulsantiera mt-4" >
         <button *ngIf="isNew" class="ds-btn ds-btn-info"
                 (click)="clickGoToEsercizio()">
            Avanti
         </button>
         <!--      <button *ngIf="!isNew" type="submit" class="ds-btn ds-btn-info"-->
         <!--              (click)="clickSalvaUtente()">-->
         <!--         Salva dati amministratore-->
         <!--      </button>-->

         <!--      <button class="ds-btn ds-btn-alert"-->
         <!--              *ngIf="!utente_esercizio?.data?.profile?.data?.email_convalidata"-->
         <!--              (click)="invia_conferma_email_click()">-->
         <!--         Reinvia Email Conferma-->
         <!--      </button>-->
      </div>
   </form>

</div>
